import {SearchUrlParams} from 'modules/search/types'

import {useRouter} from '@daedalus/core/src/_web/router/context/RouterContext'

/**
 * Builds the query string for the Search Results Page from the current Accommodation Page URL
 * @param hotelSlug - The hotel slug in the URL
 * @returns SearchUrlParams
 */
export const useSrpQueryString = (hotelSlug: string): SearchUrlParams => {
  const {getQueryParams} = useRouter()
  const {
    checkIn,
    checkOut,
    rooms,
    optimizeRooms,
    userSearch,
    freeCancellation,
    profile
  }: SearchUrlParams = getQueryParams()

  return {
    hotelId: hotelSlug,
    checkIn,
    checkOut,
    rooms,
    optimizeRooms,
    userSearch,
    freeCancellation,
    profile
  }
}
